import cn from "classnames";
import { upperFirst } from "lodash";
import styles from "./Loader.module.scss";

type LoaderProps = {
  color?: "black" | "white";
  type?: "vertical" | "horizontal";
  size?: "small" | "normal";
  text?: string;
  className?: string;
};

export const Loader = ({
  className = "",
  type = "vertical",
  color = "black",
  size = "small",
  text,
}: LoaderProps) => (
  <div
    className={cn(
      styles.loader,
      styles[`loaderType${upperFirst(type)}`],
      styles[`loaderColor${upperFirst(color)}`],
      styles[`loaderSize${upperFirst(size)}`],
      className
    )}
  >
    <div className={styles.spinner} />
    {text && <div className={styles.text}>{text}</div>}
  </div>
);
